// Единый резолвер картинки предмета для слотов инвентаря.
//
// Порядок источников (сверху вниз, каждый следующий берётся при промахе):
//   1) для ОДЕЖДЫ — CDN маджестика: clothesImages/<хеш модели>.webp
//      (хеш модели DLC считает клиент GTA-нативом, от нумерации предметов не зависит);
//   2) прямая ссылка из itemsInfo.Icon, если она задана;
//   3) «облако» document.cloud (наше зеркало cdn-ra3) — основной источник фото
//      обычных предметов: там нумерация файлов совпадает с нашими ItemId;
//   4) нарисованная иконка: категория одежды или локальный файл предмета;
//   5) глиф иконо-шрифта inv-item (когда картинки нет нигде).
//
// ⚠️ Фото предметов у маджестика по ItemId брать НЕЛЬЗЯ: у них своя нумерация,
// и по нашему id приходит чужая вещь (1 — паспорт вместо аптечки, 4 — реагент
// вместо пива, 19 — верёвка вместо ключа). Проверено 2026-08-03.
import { ItemType, ItemId } from 'json/itemsInfo.js'
import { getPng } from './getPng.js'
import { clothesMeta, clothesHashUrl } from './clothesPhoto.js'

// нарисованные иконки одежды по категориям (client_packages/interface/items/clothes)
const CLOTHES_CAT = {
    [ItemId.Top]: "tops", [-11]: "tops", [-10]: "tops",
    [ItemId.Undershit]: "undershirt", [-8]: "undershirt",
    [ItemId.Leg]: "legs", [-4]: "legs",
    [ItemId.Feet]: "shoes", [-6]: "shoes",
    [ItemId.Hat]: "hat", [-12]: "hat",
    [ItemId.Glasses]: "glasses", [-13]: "glasses",
    [ItemId.Mask]: "mask", [-1]: "mask",
    [ItemId.Gloves]: "gloves", [-3]: "gloves",
    [ItemId.Bag]: "bag", [-5]: "bag",
    [ItemId.Watches]: "watch", [-14]: "watch",
    [ItemId.Ears]: "ears", [-2]: "ears",
    [ItemId.Jewelry]: "jewelry", [-7]: "jewelry",
    [ItemId.Bracelets]: "bracelet", [-15]: "bracelet",
    [-9]: "armor",
};

export const localClothesIcon = (item, iconInfo) => {
    if (!item) return "";
    const cat = CLOTHES_CAT[item.ItemId];
    if (cat) return "items/clothes/" + cat + ".webp";
    if (iconInfo && iconInfo.functionType === ItemType.Clothes) return "items/clothes/generic.webp";
    return "";
};

// Синхронная часть списка. Адрес одежды у маджестика добавляется отдельно
// (requestMajesticClothes), потому что за хешем модели нужно сходить к клиенту.
export const buildSources = (item, iconInfo) => {
    if (!item) return [];
    const list = [];
    const isClothes = !!clothesMeta(item);

    if (iconInfo && iconInfo.Icon && (String(iconInfo.Icon).startsWith('http') || String(iconInfo.Icon).startsWith('items/')))
        list.push(iconInfo.Icon);
    list.push(getPng(item, iconInfo));
    if (isClothes) list.push(localClothesIcon(item, iconInfo));
    else list.push("items/" + item.ItemId + ".webp");

    return list.filter((url, i) => url && list.indexOf(url) === i);
};

// Спрашиваем у клиента хеш модели одежды и отдаём адрес фото у маджестика.
// onUrl вызывается только при успехе — промах просто оставит список как есть.
export const requestMajesticClothes = (item, onUrl) => {
    if (!clothesMeta(item)) return;
    clothesHashUrl(item).then((url) => { if (url) onUrl(url); }).catch(() => {});
};

export const glyphClass = (iconInfo) => {
    if (iconInfo && iconInfo.Icon && !String(iconInfo.Icon).startsWith('http') && String(iconInfo.Icon).length)
        return iconInfo.Icon;
    return "inv-item-hand-right";
};
